import { useParams, Navigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Motion";
import Seo from "@/components/Seo";
import { LEGAL } from "@/data/legal";

export default function LegalPage() {
  const { slug } = useParams();
  const content = LEGAL[slug];
  if (!content) return <Navigate to="/" replace />;

  return (
    <div className="pt-32 pb-24 min-h-screen constellation">
      <Seo title={content.title} description={`${content.title} di LUX AETERNA Spazio Olistico.`} />
      <article className="max-w-[820px] mx-auto px-6">
        <Reveal>
          <Link to="/" className="inline-flex items-center gap-2 text-[#2A1F14]/50 hover:text-gold text-sm mb-10"><ArrowLeft size={16} /> Home</Link>
          <p className="text-[10px] uppercase tracking-[0.25em] text-gold mb-4">Informazioni legali</p>
          <h1 className="font-display text-4xl sm:text-5xl text-[#2A1F14] leading-tight mb-3" data-testid="legal-title">{content.title}</h1>
          <p className="text-[#2A1F14]/40 text-sm mb-12">{content.updated}</p>
        </Reveal>
        <div className="gold-line w-full mb-12" />
        <Reveal>
          <p className="font-display italic text-2xl text-[#2A1F14]/75 leading-relaxed mb-14">{content.intro}</p>
          <div className="space-y-10">
            {content.sections.map((s, i) => (
              <section key={i}>
                <h2 className="font-display text-2xl text-gold mb-3">{s.h}</h2>
                <p className="text-[#2A1F14]/75 text-lg leading-relaxed whitespace-pre-line">{s.p}</p>
              </section>
            ))}
          </div>
        </Reveal>
      </article>
    </div>
  );
}
